import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { put, get, post, patch, destroy } from "@rails/request.js"

export default class extends Controller {

  static values = {
    updateUrl: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      onEnd: this.updatePosition.bind(this)
    })
  }

  async updatePosition(event) {
    var firstPosition = event.item.dataset.firstPosition;
    var newPosition = Number(event.newIndex) + 1;

    if (firstPosition !== undefined) {
      // We grab the firstposition so we can update the position properly
      newPosition = Number(event.newIndex) + Number(firstPosition)
    }

    var body = JSON.stringify({
      sgid: event.item.dataset.sgid,
      position: newPosition
    });

    const response = await post(this.updateUrlValue, {
      body: body
    })
    if (response.ok) {
      console.log(event.item.dataset.sgid)
    }
  }
}
